<template>
  <section id="case-view" class="enterprise-section enterprise-cases" aria-labelledby="enterprise-cases-title">
    <div class="enterprise-shell">
      <div class="enterprise-section-heading">
        <h2 id="enterprise-cases-title">{{ t('enterprise_home_cases_title') }}</h2>
        <p>{{ t('enterprise_home_cases_description') }}</p>
      </div>

      <div class="enterprise-logo-wall" :aria-label="t('enterprise_home_cases_aria')">
        <div v-for="industry in enterpriseIndustries" :key="industry.key">
          <EnterpriseIcon :src="industry.icon" />
          <span>{{ industry.name }}</span>
        </div>
      </div>

      <div class="enterprise-testimonials">
        <article v-for="(testimonial, index) in enterpriseTestimonials" :key="testimonial.organization">
          <EnterpriseIcon class="enterprise-testimonials__quote" :src="quoteIcon" />
          <p>{{ testimonial.quote }}</p>
          <span class="enterprise-testimonials__divider" />
          <div class="enterprise-testimonials__author">
            <span class="enterprise-testimonials__avatar" :class="`is-${testimonialStyles[index].tone}`">
              <EnterpriseIcon :src="testimonialStyles[index].icon" />
            </span>
            <span class="enterprise-testimonials__identity">
              <strong>{{ testimonial.organization }}</strong>
              <span>{{ testimonial.role }}</span>
            </span>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import EnterpriseIcon from '~/components/Index/enterprise/EnterpriseIcon.vue'
import bookOpenIcon from '~/assets/images/enterprise/icons/book-open.svg'
import carIcon from '~/assets/images/enterprise/icons/car.svg'
import factoryIcon from '~/assets/images/enterprise/icons/factory.svg'
import fuelIcon from '~/assets/images/enterprise/icons/fuel.svg'
import graduationCapIcon from '~/assets/images/enterprise/icons/graduation-cap.svg'
import hardHatIcon from '~/assets/images/enterprise/icons/hard-hat.svg'
import heartPulseIcon from '~/assets/images/enterprise/icons/heart-pulse.svg'
import landmarkIcon from '~/assets/images/enterprise/icons/landmark.svg'
import pillIcon from '~/assets/images/enterprise/icons/pill.svg'
import quoteIcon from '~/assets/images/enterprise/icons/quote.svg'
import scaleIcon from '~/assets/images/enterprise/icons/scale.svg'
import shoppingCartIcon from '~/assets/images/enterprise/icons/shopping-cart.svg'
import stethoscopeIcon from '~/assets/images/enterprise/icons/stethoscope.svg'
import { getEnterpriseTestimonials } from '~/config/enterpriseLanding'

const { t } = useI18n()
const enterpriseTestimonials = computed(() => getEnterpriseTestimonials(t))

const industryIcons = [
  graduationCapIcon,
  stethoscopeIcon,
  pillIcon,
  heartPulseIcon,
  factoryIcon,
  carIcon,
  fuelIcon,
  hardHatIcon,
  scaleIcon,
  landmarkIcon,
  shoppingCartIcon,
  bookOpenIcon,
]

const enterpriseIndustries = computed(() => industryIcons.map((icon, index) => ({
  key: index + 1,
  icon,
  name: t(`enterprise_home_industry_${index + 1}`),
})))

const testimonialStyles = [
  { icon: graduationCapIcon, tone: 'blue' },
  { icon: stethoscopeIcon, tone: 'green' },
  { icon: pillIcon, tone: 'orange' },
]
</script>
